import {Api, apiFetch} from "../_helpers/api";
import {apiModelName, to_url} from "../_helpers/utils";
import ResponseError from "../_data/models/ResponseError";
import User from "../_data/models/User";
import * as pluralize from "pluralize";
import {PrimaryModels} from "../_definitions/styleteq";

const LikeRepository = {
    toggle: (model: PrimaryModels, user: User) => {
        const resource = apiModelName(model);
        const likable = model as Likable;

        let data = new FormData();
        data.append(resource + '[user_id]', '' + user.id);

        return apiFetch(
            to_url(Api.apiBaseUrl, pluralize(resource), likable.id, likable.isLiked ? 'unlike' : 'like'),
            {method: 'POST', body: data}
        ).catch((error: ResponseError) => {
            console.log(error.message);
        });
    }
};

export default LikeRepository;


// WEBPACK FOOTER //
// ./app/client/_repositories/likeRepository.ts